var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 533,
    viewBox: "0 0 533 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.499 -2.07484e-06C119.55 -2.07484e-06 0 119.553 0 266.504C0 413.447 119.55 533 266.499 533C413.447 533 533 413.447 533 266.504C533 119.553 413.447 -2.07484e-06 266.499 -2.07484e-06Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.499 487C141.81 487 42 387.184 42 264.503C42 141.816 141.81 42 264.499 42C387.184 42 487 141.816 487 264.503C487 387.184 387.184 487 264.499 487",
    fill: "#2CB9F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.228 360.595C301.109 360.595 317.409 352.202 317.409 324.011C317.033 296.943 300.348 287.795 273.433 287.795H230.596V360.595H266.228ZM310.207 208.13C310.207 183.355 293.143 176.492 263.193 176.492H230.596V243.965H266.608C298.074 243.965 310.207 231.001 310.207 212.318V208.13ZM176 409V130H280.254C334.092 130 363.658 157.813 363.658 198.98V205.08C363.658 233.286 348.498 255.013 324.232 263.781C352.667 269.111 372 293.128 372 327.049V332.009C372 376.985 338.637 409 279.877 409H176",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/Bus.5d0ba946.svg";
export { ForwardRef as ReactComponent };